module.exports = __webpack_public_path__ + "img/paradas.165c715c.png";